
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "UINumberInput",
  props: {
    modelValue: {
      type: Number || undefined,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    maxLength: {
      type: Number,
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    showRequired: {
      type: Boolean,
      default: false
    },
    validData: {
      type: Boolean,
      default: true
    }
  },
  emits: [    
    "update:modelValue",
    "blur"
  ],
  setup(props, { emit }) {
    const myLabel = function() {
      return props.label;
    };
    const myPlaceHolder = function() {
      if (props.placeholder) return props.placeholder;
      else return props.label;
    };
    const myId = function() {
      if (props.id) return props.id;
      else return props.label;
    };
    function setNumber(value: number) {
      emit("update:modelValue", Number(value));
    }
    function lostFocus() {
      console.log("blur!!!!");
      emit("blur");
    }

    const showError = computed(() => {
      return (
        !props.validData ||
        (props.required &&
          props.showRequired &&
          (props.modelValue == null || props.modelValue == undefined))
      );
    });

    return {
      myLabel,
      myPlaceHolder,
      setNumber,
      myId,
      showError,
      lostFocus
    };
  }
});
